export default "__VITE_ASSET__BTQWjzbF__"